import React from 'react';
import type { RescueUnassignedInventoryDeviceItemGql } from '../../lib/rescueQueries';
import Button from '../../components/Button/Button';
import styles from './Devices.module.scss';

const EM_DASH = '\u2014';

interface UnassignedDeviceRowProps {
  device: RescueUnassignedInventoryDeviceItemGql;
  onAssign: (moduleId: string) => void;
}

export default function UnassignedDeviceRow({ device, onAssign }: UnassignedDeviceRowProps) {
  return (
    <tr>
      <td>
        <div className={styles.deviceId}>{device.moduleId}</div>
        <div className={styles.deviceType}>{device.type ?? EM_DASH}</div>
      </td>
      <td>
        <Button variant="green" size="sm" onClick={() => onAssign(device.moduleId)}>
          Add Pet
        </Button>
      </td>
    </tr>
  );
}
